import { useIntl } from "react-intl";

const Support = () => {
    const intl = useIntl();
    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.Support.header",
            defaultMessage: "Support"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.Support.body",
            defaultMessage:
                "Customer support is available with Jira Service Management’s Standard, Premium, and Enterprise plans. The Free plan has access to self-help resources in the Atlassian Community."
        }),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.Support.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about each plan’s level of support."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href="https://confluence.atlassian.com/support/atlassian-support-offerings-193299636.html#AtlassianSupportOfferings"
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.link}</p>
        </>
    );
};

export default Support;
